<template>
  <div class="container lg:px-container">
    <TermCard
      v-for="term in filteredTerms"
      :key="term.id"
      :slug="term.name"
      :markup="term.markup"
    />
  </div>
</template>
<script>
import axios from 'axios'

import TermCard from './TermCard'
import termsSetup from './termsSetup'
export default {
  name: 'TermsPortalDefault',
  components: {
    TermCard,
  },
  setup () {
    const { host, isLocal, path } = termsSetup()
    return { host, isLocal, path }
  },
  data () {
    return {
      termsHtmlList: [],
      terms: {},
    }
  },
  computed: {
    isTos () {
      return this.$route.path.includes('terms-of-service')
    },
    filteredTerms () {
      const filterBy = this.isTos ? 'tos' : 'privacy'
      return Object.entries(this.terms)
        .map(entry => entry[1])
        .filter(t => t.name.includes(filterBy))
    },
  },
  created () {
    this.fetchTerms()
  },
  methods: {
    fetchTerms () {
      axios.get(this.path)
        .then(resp => {
          resp.data.terms.forEach(t => {
            this.$set(this.terms, t.id, {
              name: t.name,
              id: t.id,
            })
            this.fetchTermById(t.id)
          })
        })
    },
    fetchTermById (id) {
      axios.get(this.path + '/' + id, {
        headers: {
          'Accept': 'text/html',
        },
      })
        .then(resp => {
          this.$set(this.terms[id], 'markup', resp.data)
        })
    },
  },
}
</script>
